import GameUtil from "../../../../utility/game_util";

const {ccclass, property} = cc._decorator;

@ccclass
export default class VideoRewardViewItem extends cc.Component {

    @property(cc.Sprite)
    rewardIcon : cc.Sprite = null

    @property(cc.Label)
    rewardLabel : cc.Label = null;

    initItem(data:any){
        this.rewardLabel.string =  "X" + GameUtil.currencyFormatting(data.awardAmount, 0);
    }
}
